import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../utils/api";
import LoadingAnimation from "../components/LoadingAnimation";

const ProtectedRoute = ({ allowedRoles }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      try {
        const res = await api.get("/api/current-user");
        const { role } = res.data;

        if (mounted) {
          setAuthorized(allowedRoles.includes(role));
        }
      } catch {
        if (mounted) {
          setAuthorized(false);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    checkAuth();
    return () => (mounted = false);
  }, [allowedRoles]);

  if (loading) return <LoadingAnimation />;
  if (!authorized) return <Navigate to="/login" replace />;

  return <Outlet />;
};

export default ProtectedRoute;
